import PropTypes from 'prop-types';
import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { bindAll } from '@bibliocommons/utils-react';
import FormatIcon from '@bibliocommons/format-icon';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

import './BibJacket.scss';

const { composeImageClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

export class BibJacket extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    const { reciprocalRank, catalogBib } = this.props;
    sendAnalyticsEvents(
      composeImageClickEvent({
        containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM,
        reciprocalRank,
        metadataId: catalogBib.get('metadataId')
      })
    );
  }

  renderPlaceholder() {
    const format = this.props.catalogBib.getIn(['brief', 'format']);
    return (
      <div className="placeholder-wrapper">
        <FormatIcon format={format} />
      </div>
    );
  }

  renderJacketCover() {
    const { catalogBib } = this.props;
    const cover = catalogBib.getIn(['brief', 'coverImage']);
    const format = catalogBib.getIn(['brief', 'format']);

    return (
      <JacketCover
        size="large"
        format={format}
        renderDefault={this.renderPlaceholder}
        src={cover}
        loadingMode="eager"
      />
    );
  }

  render() {
    const { catalogBib, renderAsLink } = this.props;
    return renderAsLink ? (
      <Link
        className="cp-bib-jacket"
        dataKey="bib-jacket-link"
        aria-hidden
        tabIndex="-1"
        href={`/v2/record/${catalogBib.get('metadataId')}`}
        rel="noopener noreferrer"
        handleClick={this.handleClick}
      >
        {this.renderJacketCover()}
      </Link>
    ) : (
      <div className="cp-bib-jacket" aria-hidden="true">
        {this.renderJacketCover()}
      </div>
    );
  }
}

BibJacket.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  renderAsLink: PropTypes.bool,
  reciprocalRank: PropTypes.number
};

export default BibJacket;
